import {
  SAVE_DOMAIN_CHANGES_REQUEST,
  SAVE_DOMAIN_CHANGES_ERROR,
  SAVE_DOMAIN_CHANGES_SUCCESS,
  SAVE_IMAGES_CHANGES_REQUEST,
  SAVE_IMAGES_CHANGES_ERROR,
  SAVE_IMAGES_CHANGES_SUCCESS,
  APPROVE_CURRENT_DOMAIN_REQUEST,
  APPROVE_CURRENT_DOMAIN_ERROR
} from './saveChangesConstants';
import { BASE_URL, UUID } from '../../../middleware/api';
import {
  SAVE_DOMAIN_DATA_AS_REVIEW,
  UPDATE_IMAGES_DATA,
  SET_UPDATE_IMAGES_FOR_LEGAL,
  APPROVE_DOMAIN
} from '../../../services/ApiEndpointsConstants';

export const saveCurrentChangesForDomain = (id, domainData) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID);
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(domainData)
    };

    dispatch({ type: SAVE_DOMAIN_CHANGES_REQUEST });

    let updateDomainData = null;

    try {
      const response = await fetch(
        `${BASE_URL}${SAVE_DOMAIN_DATA_AS_REVIEW.replace('{id}', id)}`,
        requestOptions
      );
      const result = await response.json();
      updateDomainData = result;
    } catch (error) {
      console.error('Error fetching domain data from the server', error);
    }

    if (!updateDomainData) {
      dispatch({ type: SAVE_DOMAIN_CHANGES_ERROR });
    }

    return dispatch({
      type: SAVE_DOMAIN_CHANGES_SUCCESS,
      updateDomainData
    });
  };
};

export const saveCurrentChangesForImages = (imagesData, legalCaseClick) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID);
    const checkEndPoint = legalCaseClick
      ? SET_UPDATE_IMAGES_FOR_LEGAL
      : UPDATE_IMAGES_DATA;

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(imagesData)
    };

    dispatch({ type: SAVE_IMAGES_CHANGES_REQUEST });

    let updateImagesData = null;

    try {
      await fetch(`${BASE_URL}${checkEndPoint}`, requestOptions);
      // const result = await response.json();
      // updateImagesData = result;
    } catch (error) {
      console.error('Error fetching images data from the server', error);
    }

    if (!updateImagesData) {
      dispatch({ type: SAVE_IMAGES_CHANGES_ERROR });
    }

    return dispatch({
      type: SAVE_IMAGES_CHANGES_SUCCESS,
      updateImagesData
    });
  };
};

export const approveCurrentDomain = (domainData, domainId) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID);

    dispatch({ type: APPROVE_CURRENT_DOMAIN_REQUEST });

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(domainData)
    };

    let approveData = null;

    try {
      const response = await fetch(
        `${BASE_URL}${APPROVE_DOMAIN.replace('{id}', domainId)}`,
        requestOptions
      );
      const result = await response.json();
      approveData = result;
    } catch (error) {
      console.error('Error fetching files data from the server', error);
    }

    if (!approveData) {
      dispatch({ type: APPROVE_CURRENT_DOMAIN_ERROR });
    }
  };
};
